import { render, staticRenderFns } from "./ShopView03.vue?vue&type=template&id=7a5915cc&scoped=true&"
import script from "./ShopView03.vue?vue&type=script&lang=js&"
export * from "./ShopView03.vue?vue&type=script&lang=js&"
import style0 from "./ShopView03.vue?vue&type=style&index=0&id=7a5915cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5915cc",
  null
  
)

export default component.exports